const NON_INPUT_TYPES = new Set([
  'heading',
  'subheading',
  'banner',
  'formLogo',
  'divider',
  'button',
  'prevPageButton',
  'nextPageButton',
  'captcha',
  'addPage',
  'subform',
  'ratings',
  'buttonRow'
])

export const parseFormDataSource = (raw: any): any => {
  let value = raw
  for (let i = 0; i < 3; i += 1) {
    if (typeof value === 'string') {
      try {
        value = JSON.parse(value)
      } catch {
        break
      }
    } else {
      break
    }
  }
  return value
}

const isFormElement = (el: any): boolean =>
  el && typeof el === 'object' && typeof el.type === 'string'

const isTemplateWrapper = (el: any): boolean =>
  el && typeof el === 'object' && !el.type && Array.isArray(el.formData) && el.formData.length > 0

export const resolveFormPages = (rawFormData: any): any[][] => {
  const parsed = parseFormDataSource(rawFormData)
  if (!parsed) return [[]]

  if (!Array.isArray(parsed) && Array.isArray(parsed.formData)) {
    return resolveFormPages(parsed.formData)
  }

  if (!Array.isArray(parsed)) return [[]]

  if (parsed.length === 0) return [[]]

  let pages: any[][] = Array.isArray(parsed[0]) ? parsed : [parsed]

  for (const page of pages) {
    if (!Array.isArray(page)) continue
    for (const el of page) {
      if (isTemplateWrapper(el)) {
        const nested = resolveFormPages(el.formData)
        if (nested.some((p) => p.length > 0)) return nested
      }
    }
  }

  pages = pages.map((page) => (Array.isArray(page) ? page.filter((el) => isFormElement(el)) : []))

  return pages.some((p) => p.length > 0) ? pages : [[]]
}

export const normalizeFormPages = (formData: any): any[][] => resolveFormPages(formData)

export const getFormPreviewStats = (formData: any) => {
  const pages = resolveFormPages(formData)
  let inputFieldCount = 0

  pages.forEach((page) => {
    ;(page || []).forEach((element: any) => {
      if (!element?.type || NON_INPUT_TYPES.has(element.type)) return
      if (element.label || element.type === 'signature') inputFieldCount += 1
    })
  })

  return {
    pageCount: pages.length,
    inputFieldCount
  }
}

export const getRenderablePageElements = (page: any[] | undefined): any[] =>
  (page || []).filter((el) => el?.type && !['addPage'].includes(el.type))
